export default __webpack_public_path__ + "static/media/profile.cc06aad0.svg";